import { createContext, useContext } from "react"

import { ListItemContextValues } from "./ListItem.types"

export const ListItemContext = createContext<ListItemContextValues | undefined>(undefined)
ListItemContext.displayName = "ListItem"

export default function useListItem(): ListItemContextValues {
    const context = useContext(ListItemContext)
    if (!context) {
        throw new Error("useListItem must be used within a ListItemProvider component")
    }

    return context
}
